package org.lennycodes.hldi.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.data.GalleryImage
import org.lennycodes.hldi.styles.*

@Composable
fun GalleryGrid(images: List<GalleryImage>) {
    var selectedImage by remember { mutableStateOf<GalleryImage?>(null) }

    Div(attrs = Modifier.margin(top = 0.px, bottom = 32.px, leftRight = 32.px)
        .then(GalleryGridStyle.toModifier()).toAttrs())
         {
        images.forEach { image ->
            Div(attrs = GalleryContainerStyle.toModifier().toAttrs {
                onClick { selectedImage = image }
            }) {
                Img(
                    src = image.url,
                    alt = image.title,
                    attrs = GalleryImageStyle.toModifier().toAttrs()
                )

                Div(attrs = GalleryOverlayStyle.toModifier().toAttrs()) {
                    H3(attrs = { style { fontSize(16.px); margin(8.px) } }) {
                        Text(image.title)
                    }
                    P(attrs = { style { fontSize(14.px); opacity(0.9);margin(8.px)  } }) {
                        Text(image.category)
                    }
                }
            }
        }
    }

    // Lightbox
    selectedImage?.let { image ->
        Div(
            attrs = LightboxOverlayStyle.toModifier().toAttrs {
                onClick { selectedImage = null }
            }
        ) {
            Div(
                attrs = LightboxContentStyle.toModifier().toAttrs {
                    onClick { it.stopPropagation() } // prevent closing when clicking the image/content itself
                }
            ) {
                Button(
                    attrs = LightboxCloseButtonStyle.toModifier().toAttrs {
                        onClick { selectedImage = null }
                    }
                ) {
                    Text("✕")
                }

                Img(
                    src = image.url,
                    alt = image.title,
                    attrs = LightboxImageStyle.toModifier().toAttrs()
                )

                Div(attrs = Modifier
                    .margin(8.px)
                    .then( LightboxCaptionStyle.toModifier())
                    .toAttrs()
                   ) {
                    H3(attrs = { style { fontSize(20.px); margin(8.px) } }) {
                        Text(image.title)
                    }
                    P(attrs = { style { fontSize(16.px); opacity(0.8);margin(8.px)} }) {
                        Text(image.category)
                    }
                }
            }
        }
    }
}